import _ from 'lodash'
import type { Type_ICalendarEvent, Type_IReport } from '../Type/Type.hive'

export function Cale_getEventReport(event: Type_ICalendarEvent, reports: Type_IReport[]) {
    // the report.event and the event.onlineId can sometimes be undefined
    return reports.find((r) => {
        if (r.event == null) {
            return false
        }

        if (_.isString(r.event) || _.isNumber(r.event)) {
            return r.event === event.id || r.event === event.onlineId
        }

        return r.event.id === event.id || r.event.id === event.onlineId
    })
}
